/**
 * Copyright Mántum All Rights Reserved.
 */
import request from '.';
import type { Cache, Parameter, Result, Headers } from '../type';

type Options = {
    cache?: Cache;
    headers?: Headers;
    parameter?: Parameter;
    result?: Result;
    signal?: AbortSignal;
};

export default function get<T>(url: string, options?: Options) {
    return request<T>(url, {
        cache: options?.cache,
        headers: options?.headers,
        method: 'GET',
        parameter: options?.parameter,
        result: options?.result,
        signal: options?.signal
    });
}
